import Link from 'next/link'
import styles from '@/public/styles/common/blog/tags.module.scss'

import React from "react";

const Tags = ({tags}) => {
    return (
        <div className={styles.postTags}>
            {
                tags.map(tag => {
                    return (
                        <Link prefetch={false} key={tag.urlKey} href={`/blog/tag/${tag.urlKey}`}><a>{tag.name}</a></Link>
                    )
                })
            }
        </div>
    )
}
export default Tags